import React from "react";
import { talentBadges } from "../data/anhDuongTalent";

const TalentHeroSection = () => (
  <section className="adt-hero">
    <div className="adt-hero__grid" />
    <div className="container adt-hero__inner">
      <div className="adt-hero__copy">
        <span className="adt-eyebrow">ÁNH DƯƠNG TALENT</span>
        <h1>Không gian phát triển năng lực <em>ngành Solar</em></h1>
        <p className="adt-hero__lead">Kết nối kiến thức thực tiễn, chương trình đào tạo chuyên sâu và mạng lưới chuyên gia để đồng hành cùng sự phát triển của nguồn nhân lực ngành năng lượng mặt trời.</p>
        <p className="adt-hero__motto">Học đúng kiến thức <b>—</b> Phát triển đúng năng lực <b>—</b> Kết nối đúng cộng đồng</p>
        <div className="adt-hero__badges">{talentBadges.map((badge) => <span key={badge.label}><i className={`fas ${badge.icon}`} />{badge.label}</span>)}</div>
        <div className="adt-actions">
          <a className="adt-button adt-button--primary" href="#talent-courses">Khám phá chương trình học <i className="fas fa-arrow-down" /></a>
          <a className="adt-button adt-button--ghost" href="#talent-network">Tham gia mạng lưới <i className="fas fa-arrow-down" /></a>
        </div>
      </div>
      <div className="adt-hero-visual" aria-label="Mô hình kết nối kiến thức, kỹ năng, chuyên gia và cộng đồng Solar" role="img">
        <div className="adt-orbit adt-orbit--one" /><div className="adt-orbit adt-orbit--two" />
        <div className="adt-solar-panel"><div>{Array.from({ length: 24 }).map((_, index) => <span key={index} />)}</div><i className="fas fa-sun" /></div>
        <div className="adt-visual-core"><i className="fas fa-solar-panel" /><strong>SOLAR<br />TALENT</strong><small>LEARN · APPLY · CONNECT</small></div>
        <div className="adt-floating-card adt-floating-card--knowledge"><i className="fas fa-book-open" /><span>KIẾN THỨC<small>Foundation</small></span></div>
        <div className="adt-floating-card adt-floating-card--expert"><i className="fas fa-user-tie" /><span>CHUYÊN GIA<small>Mentorship</small></span></div>
        <div className="adt-floating-card adt-floating-card--community"><i className="fas fa-people-group" /><span>CỘNG ĐỒNG<small>Network</small></span></div>
        <div className="adt-node adt-node--one" /><div className="adt-node adt-node--two" /><div className="adt-node adt-node--three" />
      </div>
    </div>
  </section>
);

export default TalentHeroSection;
